export function interfaceLanguages() {
    return axios.get(route('api.manage.languages.interface')).then(response => response.data);
}

export function communicationLanguages() {
    return axios.get(route('api.manage.languages.communication')).then(response => response.data);
}
